import React, { useEffect, useState } from "react";
import Headers from "../Common/Headers";
import { getAPIUrlBM } from "../../../utils/config";
import Get from "../../../Apis/backlink/Get";
import Post from "../../../Apis/backlink/Post";
import "./style.css";
import ListTable from "../../utils/ListTable/ListTable";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import favicon from "../Assets/Favicon.png";
import loadingGif from "../Assets/loading.gif";
// import ogImage from "../Assets/og_backLink.png";
import TablePagination from "../../utils/TablePagination/TablePagination";
import DeleteIcon from "../Assets/DeleteIcon";
import CrossIcon from "../Assets/CrossIcon";
import RouteChecker from "../../utils/RouteChecker";
import TipLoader from "../../utils/TipLoader/TipLoader";

function Lists() {
  const [searched, setSearched] = useState(null);
  const [isloading, setIsloading] = useState(true);
  const [lists, setLists] = useState();
  const navigate = useNavigate();
  const params = useParams();
  const [tipLoader, setTipLoader] = useState(false);
  const [onCompleteLoad, setOnCompleteLoad] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(
    localStorage.getItem("rowsPerPageInList") || 50,
  );
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);

  const requestSearch = async () => {
    try {
      setIsloading(true);
      const url = getAPIUrlBM();
      const res = await Post(
        url + `/searchlist/?page=${currentPage}&size=${rowsPerPage}`,
        { name: searched ?? "" },
      );
      setTotalRows(parseInt(res.metaData));
      setLists(res.data);
      setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const header = {
    heading: "Lists",
    link: "http://links.backlinkchecker.info/list-tutorial",
    subHeading: "List is a collection of backlinks you are monitoring",
    description:
      "You can define monitoring schedule, list subscribers & public URL at list level",
    isSubHeading: true,
  };

  const getLists = async () => {
    try {
      const url = getAPIUrlBM();
      const res = await Get(
        url + `/getlist?page=${currentPage}&size=${rowsPerPage}`,
      );
      setTotalRows(parseInt(res.metaData));
      setLists(res.response);
      setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const { listName } = params;
    if (listName !== undefined) getListByName();
    else if (searched !== null) requestSearch();
    else getLists();
    localStorage.setItem("rowsPerPageInList", rowsPerPage);
  }, [rowsPerPage, currentPage]);

  const getListByName = async (listName) => {
    try {
      const url = getAPIUrlBM();
      const res = await Post(url + `/searchlist/?page=${1}&size=${1}`, {
        name: listName,
      });
      setTotalRows(parseInt(res.metaData));
      setLists(res.data);
      setIsloading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const { listName } = params;
    if (listName !== undefined) getListByName(listName);
    else getLists();
  }, []);

  const deleteListItem = (listID) => {
    setLists((listss) => listss.filter((list) => list.list_id !== listID));
  };

  const [deleteAll, setDeleteAll] = useState([]);

  const DeleteAll = async (num) => {
    const url = getAPIUrlBM();

    if (num === 1) {
      window
        .sweet({
          title: "Are you sure?",
          text: `Once deleted, you will not be able to recover this list. 
           All the links & their monitoring logs will also be deleted`,
          icon: "warning",
          buttons: true,
        })
        .then(async (willDelete) => {
          if (!willDelete) {
            window.sweet({
              title: "Your list is safe!",
              icon: "success",
            });
            return;
          }
          if (willDelete) {
            const res = await Post(url + "/deleteAllList", {
              search: searched,
              listIds: deleteAll,
            });
            if (res.message === "Delete List Successfully") {
              getLists();
              window.sweet({
                title: "Your list is deleted!",
                icon: "success",
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (num === 2) {
      window
        .sweet({
          title: "Are you sure?",
          text: "All the selected lists will be activated!",
          icon: "warning",
          buttons: true,
        })
        .then(async (answer) => {
          if (!answer) {
            window.sweet({
              title: "Your list is safe!",
              icon: "success",
            });
            return;
          }
          if (answer) {
            const res = await Post(url + "/activeAllList", {
              search: searched,
              active: 1,
              listIds: deleteAll,
            });
            if (res.message === "List Actived Successfully") {
              requestSearch();
              window.sweet({
                title: "Your list is activated!",
                icon: "success",
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      window
        .sweet({
          title: "Are you sure?",
          text: "All the selected lists will be activated!",
          icon: "warning",
          buttons: true,
        })
        .then(async (answer) => {
          if (!answer) {
            window.sweet({
              title: "Your list is safe!",
              icon: "success",
            });
            return;
          }
          if (answer) {
            const res = await Post(url + "/activeAllList", {
              search: searched,
              active: 0,
              listIds: deleteAll,
            });
            if (res.message === "List DeActived Successfully") {
              requestSearch();
              window.sweet({
                text: "Your list is deactivated!",
                icon: "success",
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
      }}
    >
      <Helmet>
        <title>Lists - Backlink Checker</title>
        <meta
          name="description"
          content="You can define monitoring schedule, list subscribers & public URL at list level"
        />
        {/* <meta property="og:image" key="og:image" content={ogImage} /> */}
        {/* <meta property="og:url" content="https://app.linkly.digital/lists" /> */}
        <meta property="og:title" content="Lists - Backlink Checker" />
        <link rel="icon" type="image/png" href={favicon} sizes="16x16" />
        <meta
          property="og:description"
          content="You can define monitoring schedule, list subscribers & public URL at list level"
        />
        {/* <meta property="og:image" key="og:image" content={"/og_backLink.jpg"} /> */}
      </Helmet>
      <RouteChecker url="listScreen">
        {!isloading ? (
          <>
            {tipLoader && (
              <TipLoader
                onCompleteLoad={onCompleteLoad}
                setTipLoader={setTipLoader}
              />
            )}
            <div className="subMainContainer">
              <Headers header={header} />
              <span
                style={{
                  fontSize: "1rem",
                  fontWeight: "bold",
                  color: "blue",
                  display: "block",
                  marginBottom: "1rem",
                  cursor: "pointer",
                }}
                onClick={() => {
                  window.open(
                    "https://backlinkchecker.tawk.help/article/what-are-the-different-errors-statuses-of-links",
                    "_blank",
                  );
                }}
              >
                What do the Status & Error Code mean?
              </span>
              <div className="listBody">
                <div>
                  <p> Search</p>
                  <input
                    type="text"
                    value={searched}
                    placeholder="Search list by name"
                    className="searchField"
                    onChange={(e) => setSearched(e.target.value)}
                  />
                  <button onClick={requestSearch} className="successButton">
                    Search
                  </button>

                  <div className="delete_container">
                    <div className="delete_container_2 mr-3">
                      <input
                        type={"checkbox"}
                        checked={deleteAll.length}
                        onClick={(e) => {
                          // console.log(document.getElementById("deleteAll"));
                          if (e.target.checked) {
                            setDeleteAll(lists.map((list) => list.list_id));
                          } else {
                            setDeleteAll([]);
                          }
                        }}
                      />
                      <span className="mr-2">Select All</span>
                    </div>
                    {deleteAll && (
                      <span className="mr-2 ml-2">Bulk Actions: </span>
                    )}
                    <div className="delete_container_3">
                      {true ? (
                        <div
                          style={{
                            backgroundColor:
                              deleteAll.length > 0 ? "" : "#ebf4f5",
                            color: deleteAll.length > 0 ? "red" : "#b5c6e0",
                            borderColor: deleteAll.length > 0 ? "red" : "grey",
                          }}
                          className="deleteAll"
                          onClick={
                            deleteAll.length ? () => DeleteAll(1) : () => {}
                          }
                        >
                          <span>Delete All</span>
                          <DeleteIcon
                            color={deleteAll.length > 0 ? "red" : "#b5c6e0"}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                      {true ? (
                        <div
                          style={{
                            backgroundColor:
                              deleteAll.length > 0 ? "" : "#ebf4f5",
                            color: deleteAll.length > 0 ? "#4caf50" : "#b5c6e0",
                            borderColor:
                              deleteAll.length > 0 ? "#4caf50" : "grey",
                          }}
                          className="deleteAll"
                          onClick={
                            deleteAll.length ? () => DeleteAll(2) : () => {}
                          }
                        >
                          <span>Activate All</span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            x="0px"
                            y="0px"
                            width="24"
                            height="24"
                            viewBox="0 0 48 48"
                          >
                            <path
                              fill={
                                deleteAll.length > 0 ? "#4caf50" : "#b5c6e0"
                              }
                              d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
                            ></path>
                            <path
                              fill="#ccff90"
                              d="M34.602,14.602L21,28.199l-5.602-5.598l-2.797,2.797L21,33.801l16.398-16.402L34.602,14.602z"
                            ></path>
                          </svg>
                        </div>
                      ) : (
                        ""
                      )}
                      {true ? (
                        <div
                          style={{
                            backgroundColor:
                              deleteAll.length > 0 ? "" : "#ebf4f5",
                            color: deleteAll.length > 0 ? "grey" : "#b5c6e0",
                            borderColor: deleteAll.length > 0 ? "grey" : "grey",
                          }}
                          className="deleteAll"
                          onClick={
                            deleteAll.length ? () => DeleteAll(3) : () => {}
                          }
                        >
                          <span>Deactivate All</span>
                          <CrossIcon
                            color={deleteAll.length > 0 ? "grey" : "#b5c6e0"}
                          />
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="linkTable">
                  <table>
                    <tbody>
                      <tr className="tableHead">
                        <th className="text-center p-2 link">List Name</th>
                        <th className="text-center p-2 link">Is Public</th>
                        <th className="text-center p-2 link">Frequency</th>
                        <th className="text-center p-2 link">Subscribers</th>
                        <th className="text-center p-2 link">Last Checked</th>
                        <th className="text-center p-2 link">Total URLs</th>
                        <th className="text-center p-2 link">Notes</th>
                        <th className="text-center p-2 link">
                          Present | Not Checked | Absent | Error | OK
                        </th>
                        <td
                          className="grey-text p-2 "
                          style={{
                            maxWidth: "5rem",
                          }}
                        >
                          Check Indexing
                        </td>
                        <th className="text-center p-2 link">
                          {"            "}
                        </th>
                      </tr>
                      {lists?.length !== 0 ? (
                        lists?.map((list, index) => {
                          return (
                            <ListTable
                              key={index}
                              data={list}
                              id={list?.list_id}
                              open={index === 0}
                              deleteListItem={deleteListItem}
                              setTipLoader={setTipLoader}
                              setOnCompleteLoad={setOnCompleteLoad}
                            />
                          );
                        })
                      ) : lists?.length === 0 && searched === null ? (
                        <>
                          <tr>
                            <td colSpan={9}>
                              <div className="centerDiv">
                                <button
                                  onClick={() => navigate("/backlink/list/add")}
                                  className={"submitButton"}
                                >
                                  Create New List
                                </button>
                              </div>
                            </td>
                          </tr>
                        </>
                      ) : (
                        <tr>
                          <td colSpan={9}>
                            <div className="centerDiv">
                              <p className="noData">No result found!!</p>
                            </div>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <TablePagination
              rowsPerPage={rowsPerPage}
              setRowsPerPage={setRowsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalRows={totalRows}
              bgColor={"#f9fafb"}
            />
          </>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "89vh",
              margin: "-15px -30px",
            }}
          >
            <img
              style={{
                width: "82vw",
                height: "94vh",
              }}
              alt=""
              src={loadingGif}
            />
          </div>
        )}
      </RouteChecker>
    </div>
  );
}

export default Lists;
